import React from "react";
import { Tabs, withStyles } from "@material-ui/core";

export const StyledTabs = withStyles((theme) => ({
    root: {
        height: 50,
        minHeight: "auto",
    },
    indicator: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
        "& > span": {
            height: 4,
            alignSelf: "flex-end",
            // maxWidth: "75%",
            width: "100%",
            backgroundColor: "#304D6E",
        },
    },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
